import { ChatService } from '@messages/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ChannelDetailsQueryParam } from '../../../enums';
import { ChannelDetailsPayloadModel } from '../../../interfaces';
import { ChannelDetailsQueryResult } from '../channel-details/channel-details.query-result';

export class ChannelDetailsByReferenceQueryHandler {
  private readonly chatService: ChatService = inject(ChatService);

  details(payload: ChannelDetailsPayloadModel): Observable<ChannelDetailsQueryResult> {
    const params = (): string => {
      if (payload.param === ChannelDetailsQueryParam.TEAM) return `teamId=${payload.teamId}`;
      return `gameId=${payload.gameId}`;
    };

    return this.chatService.channelDetailsByReference(params());
  }
}
